import request from './index'

export const dataWarningList=(carId,listQuery)=>{
    return request({
        url:'/warning/getByCarIdPage',
        method: 'post',
        data:{
            command_id: 0,
            carId: carId,
            pageIndex: listQuery.pageIndex,
            pageSize: listQuery.pageSize,
        }
    })
}

export const deleteWarning= id =>{
    return request({
        url:'/warning/delete',
        method: 'delete',
        data:{
            command_id: 0,
            id:id
        }
    })
}

export const handleWarning = id =>{
    return request({
        url:'/warning/handle',
        method: 'post',
        data:{
            command_id: 0,
            id:id
        }
    })
}

export const getUnHandle = entityId =>{
    return request({
        url:'/warning/getUnHandle',
        method: 'post',
        data:{
            command_id: 0,
            entityId:entityId
        }
    })
}

export const alarmList = listQuery => {
  return request({
    url: '/warning/alarmListPage',
    method: 'post',
    data: {
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: listQuery.params,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}

export const updateAlarm = formAlarmData => {
	return request({
		url:'/warning/updateAlarm',
		method:'post',
		data:{
			id:formAlarmData.id,
			alarmCode:formAlarmData.alarmCode,
			alarmName: formAlarmData.alarmName,
			alarmStatus: formAlarmData.alarmStatus
		}
	})
}

export const deleteAlarm = (id) => {
	return request({
		url:'/warning/deleteAlarm',
		method:'post',
		data:{
			id:id
		}
	})
}